import type { CardElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'
import { useState } from 'react'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './CardElement'
import type { CardDemoType } from './cardTypes'

const DEMO_VALUE: CardElementValue = {
  front: {
    label: textToRtValue(t('elements.card.tags.sideA')),
    image: null,
    overlay: null,
  },
  back: {
    label: textToRtValue(t('elements.card.tags.sideB')),
    image: null,
    overlay: null,
  },
}

const CardDemo: CardDemoType = ({ styles, fonts, feedback }) => {
  const [state, setState] = useState({ isBack: false, pauseAnimation: false })

  return (
    <DemoWrapper center>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.card.type}-demo`,
          type: CONFIG_ELEMENTS.card.type,
          value: DEMO_VALUE,
          style: {},
          font: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        setState={setState}
        state={state}
        styles={styles}
      />
    </DemoWrapper>
  )
}

export default CardDemo
